import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop
 * - On every route change, jump instantly to top of page (no smooth scroll).
 * - Place this component inside your Router (i.e. inside BrowserRouter).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instant jump to top (flash) when path changes
    // use 'auto' for instant behavior (not 'smooth')
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
